<template>
  <div
    class="i-quiz-sticky-bar"
    :class="{ show: visible }"
  >
    <div class="inner">
      <div class="label">{{ label }}</div>
      <button
        class="btn"
        @click="$emit('checkout')"
      >
        {{ btnText }}
      </button>
    </div>
  </div>
</template>

<script setup>
defineEmits(["checkout"])

defineProps({
  visible: Boolean,
  label: { type: String, default: "Ready to fix your trajectory?" },
  btnText: { type: String, default: "Book Call →" }
})
</script>

<style lang="scss" scoped>
.i-quiz-sticky-bar {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 90;
  background: #fffffff2;
  border-top: 1px solid #11182714;
  padding: 12px 20px;
  box-shadow: 0 -2px 12px #00000014;

  @include respond-to($breakpoint-md) {
    padding: 16px 40px;
  }

  &.show {
    display: block;
  }

  .inner {
    max-width: 680px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    gap: 12px;
    justify-content: center;
    flex-direction: column;

    @include respond-to($breakpoint-sm) {
      flex-direction: row;
      gap: 16px;
    }
  }

  .label {
    font-size: 13px;
    color: $ink-60;
    text-align: center;
  }

  .btn {
    background: $amber-mid;
    color: $white;
    font-family: $sans;
    font-size: 14px;
    font-weight: 600;
    padding: 11px 28px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    transition: opacity 0.2s;
    white-space: nowrap;
    width: 100%;

    @include respond-to($breakpoint-sm) {
      font-size: 15px;
      padding: 12px 32px;
      width: auto;
    }

    &:hover {
      opacity: 0.88;
    }
  }
}
</style>
